export enum Role {
  User = 0,
  Admin = 1
}

export const Roles: Role[] = [Role.User, Role.Admin];

export function getRoleName(roleValue: number): string {
  return Role[roleValue];
}